import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, UserRound, GraduationCap, ShieldCheck } from "lucide-react";

const OPTIONS = [
  { to: "/applicant/login", label: "Applicant", desc: "Track your visa case",     Icon: UserRound },
  { to: "/student/login",   label: "Student",   desc: "Uni, SOP, IELTS, visa",    Icon: GraduationCap },
  { to: "/crm/login",       label: "Staff",     desc: "Advisor & Ops dashboard",  Icon: ShieldCheck },
];

export default function PortalLoginDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="portal-login-dropdown"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-app-muted hover:text-[#C9A961] transition-colors"
      >
        Sign in <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="portal-login-menu"
          className="absolute right-0 mt-3 w-64 rounded-2xl border border-[var(--card-border)] bg-app shadow-xl overflow-hidden z-50"
        >
          {OPTIONS.map(({ to, label, desc, Icon }) => (
            <Link
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              data-testid={`portal-option-${label.toLowerCase()}`}
              className="flex items-start gap-3 px-4 py-3 hover:bg-[#C9A961]/10 transition-colors border-b border-[var(--card-border)] last:border-b-0"
            >
              <div className="w-8 h-8 rounded-lg bg-[#0B1E3F] text-[#C9A961] flex items-center justify-center shrink-0">
                <Icon className="w-4 h-4" />
              </div>
              <div>
                <div className="text-sm font-semibold text-app">{label}</div>
                <div className="text-[11px] text-app-muted">{desc}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
